import React from 'react';
import '../Plane/Plane.css';
import _ from 'lodash';

const Plane = () => {
	return (
		<div className='plane-container'>
			<div className='plane' dangerouslySetInnerHTML={{__html: _.unescape(`<svg version="1.1"

xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"

x="0px" y="0px" width="104px" height="48px" viewBox="0 0 933.5 436.5" style="enable-background:new 0 0 933.5 436.5;"

xml:space="preserve">

<style type="text/css">

.st0{fill:#503854;}

</style>

<defs>

</defs>

<g>

<path class="st0" d="M928.5,4.8c-4.3,17.5-8.7,34.9-12.9,52.4c-12,49.9-23.9,99.8-35.9,149.7c-0.3,1.1-0.4,2.3-0.8,3.4

   c-1.5,4.4,0.5,5.6,4.6,5.6c12.5-0.1,25-0.1,37.5,0c10.4,0.1,12.6,2.4,12.7,12.7c0,7.8-0.1,15.7-0.4,23.5c-0.4,8.8-3.5,12.6-12,14.8

   c-11.5,3-23.4,3.2-35.1,4.4c-40.7,4.1-81.5,8-122.2,12.1c-38.7,3.9-77.5,7.9-116.2,11.7c-39.2,3.8-78.5,1.7-117.8,2

   c-13,0.1-26,0.2-39-0.1c-4.1-0.1-5.4,1.3-5.2,5.1c0.1,3-0.4,6-0.3,9c0.2,4.4-1.7,5.6-6,5.6c-31.1-0.5-62.3-0.8-93.4-1.3

   c-27-0.4-53.9-0.9-80.9-1.5c-6.7-0.1-6.8-0.5-7.1-7.3c-0.6-13.3,0.4-10.9-11.2-11.2c-57.9-1.4-115.8-2.7-173.8-4

   c-31.9-0.7-62.3-8.2-91.5-20.8c-6-2.6-11.5-6-16.2-10.7c-7.1-7-7.1-13.6,0.4-20.1c11.7-10.2,23.9-19.7,36.4-28.9

   c4.9-3.6,10.3-4.9,16.3-4.9c72.9,0,145.8,1.1,218.8,1.9c145.7,1.6,291.3,3.3,437,5.1c4,0,6.3-1.3,8.7-4.3

   c37-46.2,74.1-92.3,111.2-138.3c17.3-21.4,34.7-42.6,51.9-64.1c3.9-4.8,8.2-7.1,14.5-6.4c9.1,0.9,18.3-0.5,27.3,1.7

   C928,2.8,928.2,3.8,928.5,4.8z"/>

</g>

<path class="st0" d="M206.8,246.2c0,0,312.1,162.4,371.8,188.2c59.7,25.8-159.5-210.4-159.5-210.4L206.8,246.2z"/>

</svg>`)}} />
		</div>
	);
};

export default Plane;
